import { forwardRef } from "react";
import { Button, ButtonProps } from "@/components/ui/button";
import { usePlatform } from "@/hooks/usePlatform";
import { hapticButtonPress } from "@/utils/haptics";
import { cn } from "@/lib/utils";

interface PlatformOptimizedButtonProps extends ButtonProps {
  enableHaptic?: boolean;
}

export const PlatformOptimizedButton = forwardRef<
  HTMLButtonElement,
  PlatformOptimizedButtonProps
>(({ className, onClick, enableHaptic = true, ...props }, ref) => {
  const { isAndroid, isIOS, isMobile } = usePlatform();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (enableHaptic && isMobile) {
      hapticButtonPress();
    }
    onClick?.(e);
  };

  return (
    <Button
      ref={ref}
      className={cn(
        "no-select",
        // Touch-optimized sizes
        isMobile && "touch-target",
        // Android-specific styles with enhanced ripple
        isAndroid && "ripple-dark android-elevation-1 active:android-elevation-2",
        // iOS-specific styles with spring animation
        isIOS && "ios-transition active:animate-ios-press",
        className
      )}
      onClick={handleClick}
      {...props}
    />
  );
});

PlatformOptimizedButton.displayName = "PlatformOptimizedButton";
